import ConfigsUtils from './aem-configs/config-utils.js';
import { _LOCALE_, _defaultChannelId } from './vars.js';

const SNOWSTORM_CONFIRM_REDIRECT_CONFIG_KEY = 'snowstorm-confirm-redirect';
const CONFIRM_RESERVATION_REDIRECT_CONFIG = 'confirmReservationRedirect';

function isConfirmReservationRedirectEnabled() {
  return ConfigsUtils.getConfigs(SNOWSTORM_CONFIRM_REDIRECT_CONFIG_KEY, _defaultChannelId, [_LOCALE_], ConfigsUtils.Any).some(
    (item) => item.name === CONFIRM_RESERVATION_REDIRECT_CONFIG && item.value === 'true'
  );
}

export function getTravelPackagesRedirectData(res) {
  if (!res || !res.purlUrl) {
    return null;
  }

  return {
    redirectUrl: res.purlUrl
  };
}

export function canRedirectToTravelPackagesConfirm(res) {
  return isConfirmReservationRedirectEnabled() && !!getTravelPackagesRedirectData(res);
}

export function redirectToTravelPackagesConfirm(res) {
  const redirectData = getTravelPackagesRedirectData(res);

  if (!isConfirmReservationRedirectEnabled() || !redirectData) {
    return false;
  }

  window.location.href = redirectData.redirectUrl;

  return true;
}
